import { ItemListingGroupingState } from './types';

export const defaultState: ItemListingGroupingState = {
  error: undefined,
  loading: {
    create: false
  }
};
